// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForCard = makeThemedStyles('CardGrid.Card', () => ({
  Card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f9f9f9',
    margin: '0px',
    fontSize: '13px',
    boxShadow: 'none',
    borderRadius: '7px',
    padding: '1em'
  },

  noPadding: {
    padding: '0px'
  },
  leftBorder: {
    borderLeft: '7px solid #115e67'
  },
  shadowBorder: {
    boxShadow: '0 0px 1px rgb(0 0 0 / 0.4)'
  },
  largeShadow: {
    boxShadow: '0 0px 10px rgb(0 0 0 / 0.5)'
  },
  hoverShadow: {
    '&:hover': { boxShadow: '0 0px 10px rgb(0 0 0 / 0.5)' }
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const CardComponent: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForCard();

  /* eslint-disable */
  return (
    <div
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.Card, {
        [styles.noPadding]: isVariantEnabled(props, 'noPadding'),
        [styles.leftBorder]: isVariantEnabled(props, 'leftBorder'),
        [styles.shadowBorder]: isVariantEnabled(props, 'shadowBorder'),
        [styles.largeShadow]: isVariantEnabled(props, 'largeShadow'),
        [styles.hoverShadow]: isVariantEnabled(props, 'hoverShadow')
      })}
    >
      {props?.children}
    </div>
  );
};
export default CardComponent;
